import { render, staticRenderFns } from "./wrestler_roster_edit.vue?vue&type=template&id=a2c37ede&"
import script from "./wrestler_roster_edit.vue?vue&type=script&lang=js&"
export * from "./wrestler_roster_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports